import React, { Component } from 'react';
//import './Header.css';
//import './bootstrap.min.css';
import LeftMenu from './LeftMenu/LeftMenu';
import TopMenu  from './TopMenu/TopMenu';
import { ProfileMenu } from './ProfileMenu';
import { getAppLogo } from './Common/Utilities';

export class Header extends Component {
    constructor() {
        super();
        this.state = {
            changePath: "/"
        };

    }
    changeState = (updatedPath) => {
        
        this.setState({ changePath: updatedPath });
    }
    render() {

        const { tokenHandler, appEnvironment } = this.props;

		return (
			<header>
                <div className="container-fluid zero-padding zero-margin">
                    <div className="col-md-12 page-header zero-padding zero-margin">
                        <div className="col-md-12 page-header-top zero-padding zero-margin">

                            <div className="container zero-padding">
                            
                                <LeftMenu updateLeftMenu={this.state.changePath}/>

                                <div className="page-logo">
                                    <img src={getAppLogo(appEnvironment)} alt="Media Planning Logo" className="logo-default" />
                                </div>

                                <TopMenu tokenHandler={tokenHandler} RenderHeader={this.changeState} />

                                <div className="top-menu" style={{ display: "none" }}>
                                    <ProfileMenu/>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
			</header>
		);
	}
}